import * as RequestParam from '../../constants/RequestParam';

const initialState = {
  hash: '',
  pathname: '',
  search: {},
  state: {}
};

export default function loadParam(state: any = initialState, action: any) {

  switch (action.type) {
    case RequestParam.LOADED:
      return Object.assign({}, state, action.message);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/RequestParam.tsx